import { createSlice } from "@reduxjs/toolkit";
import { setGetLocalData } from "utils/localStorageHelper";

let sessionToken = setGetLocalData("token");

export const initialState = {
  data: "",
  token: sessionToken || "",
  userResources: {},
};

export const localDataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    setAuthToken: (state, action) => {
      state.token = action.payload;
    },

    setUserResources: (state, action) => {
      state.userResources = action.payload;
    },
  },
});

export const { setAuthToken, setUserResources } = localDataSlice.actions;

export default localDataSlice.reducer;
